import { Stack, styled } from '@mui/material';

export const StyledCaseStudySection = styled(Stack)<{ noGap?: boolean }>(
  ({ noGap = false, theme }) => ({
    maxWidth: '660px',
    width: '100%',
    display: 'flex',
    alignSelf: 'center',
    gap: noGap ? 0 : theme.spacing(2),
    padding: theme.spacing(2, 0),
    [theme.breakpoints.down('md')]: {
      gap: noGap ? 0 : theme.spacing(1),
      padding: theme.spacing(1, 0),
    },
  })
);

export const DetailsStackWrapper = styled(Stack)(({ theme }) => ({
  maxWidth: '433px',
  width: '100%',
  gap: theme.spacing(4),
  [theme.breakpoints.down('md')]: {
    gap: theme.spacing(2),
  },
}));
